import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('visual-olivio-design')
export class VisualOlivioDesign extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			width: 100%;
		}
		video {
			height: 95%;
			object-fit: cover;
			object-position: bottom center;
			margin: 0 auto;
			display: block;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				[Olivio Design]
			</div>
		`;
	}
}
